(function(){
  function init(root){
    var cats = root.querySelector('[data-knw-cats]');
    if (!cats || cats.__knw) return; cats.__knw = 1;
    var tiles = cats.querySelectorAll('[data-knw-cat]');
    var now = cats.querySelector('[data-knw-now]');
    var cache = {}, original = null, busy = false;
    function gridWrap(){ var m = document.querySelector('[main-content]'); return m ? (m.closest('.shopify-section') || m) : null; }
    function headerOffset(){
      var h = document.querySelector('sticky-header, .hdt-header, .shopify-section-group-header-group, header');
      var r = h ? h.getBoundingClientRect() : null;
      return (r && r.top <= 2 && r.height < 200 ? r.height : 0) + 16;
    }
    function scrollToGrid(smooth){
      var w = gridWrap(); if (!w) return;
      window.scrollTo({ top: w.getBoundingClientRect().top + window.pageYOffset - headerOffset(), behavior: smooth ? 'smooth' : 'auto' });
    }
    function setActive(handle, name, count){
      tiles.forEach(function(t){ t.classList.toggle('is-active', t.getAttribute('data-knw-cat') === handle); });
      if (handle){ now.hidden = false; now.querySelector('[data-knw-now-name]').textContent = name; now.querySelector('[data-knw-now-count]').textContent = count; }
      else now.hidden = true;
      try { var u = new URL(location.href); if (handle) u.searchParams.set('cat', handle); else u.searchParams.delete('cat'); u.searchParams.delete('page'); history.replaceState(history.state, '', u.pathname + u.search); } catch(e){}
    }
    function swap(node){ var cur = gridWrap(); if (!cur || !node) return; if (!original) original = cur; cur.replaceWith(node); }
    function load(tile, smooth){
      if (busy) return;
      var handle = tile.getAttribute('data-knw-cat'), name = tile.getAttribute('data-name'), count = tile.getAttribute('data-count');
      if (!handle){ if (original && gridWrap() !== original) swap(original); setActive('', '', ''); scrollToGrid(smooth); return; }
      var url = tile.getAttribute('href'), cur = gridWrap();
      if (cur) cur.classList.add('knw-ch-loading');
      busy = true;
      var p = cache[url] ? Promise.resolve(cache[url]) : fetch(url, { credentials: 'same-origin' }).then(function(r){ if (!r.ok) throw 0; return r.text(); });
      p.then(function(html){
        cache[url] = html;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var m = doc.querySelector('[main-content]'); if (!m) throw 0;
        var node = document.importNode(m.closest('.shopify-section') || m, true);
        if (cur) cur.classList.remove('knw-ch-loading');
        swap(node); setActive(handle, name, count); busy = false;
        requestAnimationFrame(function(){ scrollToGrid(smooth); });
      }).catch(function(){ busy = false; location.href = url; });
    }
    tiles.forEach(function(t){ t.addEventListener('click', function(e){ if (e.metaKey || e.ctrlKey || e.shiftKey) return; e.preventDefault(); load(t, true); }); });
    var rb = cats.querySelector('[data-knw-reset]'); if (rb) rb.addEventListener('click', function(){ load(tiles[0], true); });
    try { var s = new URL(location.href).searchParams.get('cat'); if (s){ var t = cats.querySelector('[data-knw-cat="' + s.replace(/[^a-z0-9_-]/gi, '') + '"]'); if (t) load(t, false); } } catch(e){}
  }
  function run(){ document.querySelectorAll('.knw-ch').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();